import BarcodeResults from './BarcodeResults';

export default BarcodeResults;
